import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightRegistrationAbandonedEventName = 'FREIGHT_REGISTRATION_ABANDONED';

export const useTrackFreightRegistrationAbandoned = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightRegistrationAbandonedEventName, { env: environment });
  }, []);
};
